import { AnalyticsType, getAnalyticTags, gotoUrl } from "@menu/core/lib";
import imageSrc from "@menu/core/lib/image-src";
import { MenuSite, NavItem } from "@menu/core/types";

type SiteLogoProps = {
  site: MenuSite,
  isMobile?: boolean,
  className?: string,
  spanWrap?: boolean
}

const gotvRx = /https:\/\/(www|u8-qa)\.gotvafrica\.com\/([a-z]{2}-[a-z]{2})/;

const findGotvLink = (navItems: NavItem[]) => {
  const allLinks = navItems.flatMap(navItem => [
    navItem.link,
    ...(navItem.subnavItems?.map(sub => sub.link) ?? [])
  ]);

  return allLinks.find(link => gotvRx.test(link)) ?? null;
}

const SiteLogo = (props: SiteLogoProps) => {
  const {
    className = "site-logo",
    site,
    isMobile = false,
    spanWrap = true
  } = props;

  if (!site) {
    return null;
  }

  const gotvUrl = findGotvLink(site.navItems ?? []);
  const url = gotvUrl ? gotvUrl : site.link;
  const height = isMobile ? site.logoMobileHeight : site.logoHeight;
  const name = site.title;
  const imageUrl = imageSrc(site.image);

  const analytics = getAnalyticTags({
    component_name: "home_icon_click",
    nav_item: AnalyticsType.topLevel,
    nav_text: name,
    target_page_url: url
  });

  const image = () => {
    const css = spanWrap ? {} : { className: className };

    return (<img
      {...analytics}
      {...css}
      src={imageUrl}
      style={{ height: height }}
      alt={name}
      onClick={() => gotoUrl(url)} />);
  }

  if (!spanWrap) {
    return image();
  }

  //Note: span is use as a parent element because flex-basis is used
  //for mobile & we want the user to only be able to click on the image.
  return (<span className={className}>{image()}</span>);
}

export default SiteLogo;
